import { AuthContainer } from 'containers/AuthFlow/styled';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import SimpleHeader from 'components/SImpleHeader';

import { LayoutProps } from '../types';

const PublicLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet title={t(titleKey)} />
            <SimpleHeader />
            <AuthContainer>{children}</AuthContainer>
        </>
    );
};

export default PublicLayout;
